import {
  Component,
  OnInit,
  Input,
  forwardRef,
  ElementRef,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  NG_VALIDATORS,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { SharedComponentsUtil } from '../utils/classes/SharedComponentsUtil';
import { MessageUtilService } from '../utils/service/message-util.service';
import { InputTextService } from './input-text.service';

@Component({
  selector: 'input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true,
    },
  ],
})
export class InputTextComponent
  implements OnInit, OnChanges, AfterViewInit, ControlValueAccessor
{
  @Input() format: string = 'M';
  @Input() showLabel: boolean = true;
  @Input() label: any = '';
  @Input() btnEnable: boolean = false;
  @Input() autocomplete: string = 'cc-csc';
  @Input() bold: boolean = false;
  @Input() inputMask: any = null;
  @Input() next: any;
  @Input() nextIsDisable: any;
  @Input() back: any;
  @Input() backIsDisable: any;
  @Input() required: boolean = false;
  @Input() textRight: boolean = false;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() validatorMessage: boolean = false;
  @Input() tooltipMessage: boolean = true;
  @Input() maxLength: any = null;
  @Input() submitted: boolean = true;
  @Input() validatorAlert: boolean = false;
  @Input() setNgClass: string = '';
  @Input() patterns: any = '';
  @Input() placeholder: string = '';

  @Output() onNext: EventEmitter<any> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() onfocus: EventEmitter<any> = new EventEmitter();
  @Output() onchange: EventEmitter<any> = new EventEmitter();
  @Output() onfocusout: EventEmitter<any> = new EventEmitter();

  @ViewChild('inputText') private _inputText!: ElementRef<HTMLInputElement>;

  controls: any;
  value: any;
  sharedComponentsUtil = new SharedComponentsUtil();

  constructor(
    private messageUtilService: MessageUtilService,
    private inputTextService: InputTextService
  ) {
    this.format = this.inputTextService.getFormat();
    this.showLabel = this.inputTextService.getShowLabel();
    this.btnEnable = this.inputTextService.getBtnEnable();
    this.bold = this.inputTextService.getBold();
    this.textRight = this.inputTextService.getTextRight();
    this.validatorMessage = this.inputTextService.getValidatorMessage();
    this.tooltipMessage = this.inputTextService.getTooltipMessage();
    this.submitted = this.inputTextService.getSubmitted();
    this.validatorAlert = this.inputTextService.getValidatorAlert();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.submitted) {
      if (this.controls !== undefined && changes.submitted.currentValue) {
        this.controls.markAsDirty();
        this.controls.markAsTouched();
      }
    }
  }

  ngOnInit() {}

  ngAfterViewInit(): void {}

  get nativeElement(): HTMLInputElement {
    return this._inputText.nativeElement;
  }

  onChange = (_: any) => {};
  onValidationChange = () => {};
  onTouch = () => {};
  focus = () => {
    // this.inputText.nativeElement.focus();
    // this.inputText.nativeElement.select();
    this.nativeElement?.focus();
    this.nativeElement?.select();
  };

  onBlur(value: string): void {
    // this.value = this.formatInput(value);
    this.onTouch();
    // this.onValidationChange();
    // this.onChange(this.value);
    this.blur.emit(this.formatInput(value));
  }

  onFocus(value: string): void {
    if (value.trim() !== '') {
      this.nativeElement?.select();
      this.onfocus.emit(value.trim());
    }
  }

  onInput(value: string): void {
    const newValue = this.formatInput(value);

    this.onTouch();
    this.onChange(newValue);
    this.onValidationChange();
    this.onchange.emit(newValue);
    this.change.emit(newValue);
  }

  writeValue(value: any): void {
    if (value) {
      this.value = this.formatInput(value);
      this.onChange(value);
    } else {
      this.value = null;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | any {
    this.controls = control;
    return null;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChange = fn;
  }

  formatInput(value: string): string {
    // if (this.format === 'M' && value !== null && value !== '') {
    //   return value.toString().toUpperCase();
    // } else if (this.format === 'm' && value != null && value != '') {
    //   return value.toString().toLowerCase();
    // }

    if (value !== null && value.trim() !== '') {
      const newValue = value.trim();

      if (this.format === 'M') return newValue.toUpperCase();
      if (this.format === 'm') return newValue.toLowerCase();
    }

    return value;
  }

  enterKeyUp() {
    if (!this.disabled) {
      let validator = this.sharedComponentsUtil.stopByValidator(
        this.controls,
        this.validatorAlert,
        this.label
      );
      if (validator.error) {
        this.messageUtilService.getMessageError(
          '000046',
          'Error',
          validator.message
        );
        return;
      }
    }
    if (this.next != undefined) {
      if (this.next.disabled || this.next.readonly) {
        if (this.nextIsDisable != undefined) {
          this.nextIsDisable.focus();
        }
      } else {
        this.next.focus();
      }
    } else {
      if (this.nextIsDisable != undefined) {
        this.nextIsDisable.focus();
      } else {
        this.onNext.emit();
      }
    }
  }

  arrowUpKeyUp() {
    if (!this.disabled) {
      let validator = this.sharedComponentsUtil.stopByValidator(
        this.controls,
        this.validatorAlert,
        this.label
      );
      if (validator.error) {
        this.messageUtilService.getMessageError(
          '000046',
          'Error',
          validator.message
        );
        return;
      }
    }
    if (this.back != undefined) {
      if (this.back.disabled || this.back.readonly) {
        if (this.backIsDisable != undefined) {
          this.backIsDisable.focus();
        }
      } else {
        this.back.focus();
      }
    } else {
      if (this.backIsDisable != undefined) {
        this.backIsDisable.focus();
      } else {
        this.onBack.emit();
      }
    }
  }

  onFocusOut(evt: any) {
    this.onfocusout.emit(evt);
    if (this.btnEnable) {
      this.disabled = true;
    }
  }

  clickEnable() {
    this.disabled = false;
    this.readonly = false;
    setTimeout(() => {
      this.focus();
    }, 150);
  }
}
